<template>
  <div class="message-align-container">
    <div :class="'message-detail-container' + getDetailAlignClass()">
      <MessageAction></MessageAction>
      <div :class="'message-data'">
        <span class="message-data-name">{{ getMessageTitle() }}</span>
        <span class="message-data-time">{{ getMessageDate() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TipoMensagem from "../../enums/TipoMensagem";
import OrigemMensagem from "../../enums/OrigemMensagem";
import MessageAction from "./MessageAction";

export default {
  components: {
    MessageAction
  },
  props: {
    ownerName: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    origin: {
      type: Number,
      default: -1
    },
    type: {
      type: Number,
      default: -1
    },
    scheduled: {
      type: Boolean,
      default: false
    },
    editada: {
      type: Boolean,
      default: false
    },
    deleted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    TipoMensagem() {
      return TipoMensagem;
    },
    OrigemMensagem() {
      return OrigemMensagem;
    }
  },
  methods: {
    getMessageTitle() {
      if (this.deleted) {
        return "(Mensagem Apagada)  " + this.ownerName;
      }

      if (this.scheduled) {
        return "(Mensagem Agendada)  " + this.ownerName;
      }

      if (this.editada) {
        return "(Mensagem Editada)  " + this.ownerName;
      }

      if (this.type == TipoMensagem.Interna) {
        return "(Mensagem Interna)  " + this.ownerName;
      }

      if (this.type == TipoMensagem.Log) {
        return "Mensagem de Log";
      }

      return "" + this.ownerName;
    },
    getMessageDate() {
      var date = new Date(this.date);

      if (!date) return;

      var formatedDate =
        date.toLocaleTimeString() + ", " + date.toLocaleDateString();
      return formatedDate;
    },
    getDetailAlignClass() {
      if (OrigemMensagem.Recebida == this.origin) {
        return " mr-auto";
      }
      if (OrigemMensagem.Enviada == this.origin) {
        return " ml-auto";
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
@import "/scss/main.scss";

.message-data {
  color: black;
  pointer-events: auto;
  margin: 0 0 0.5rem 0.2rem;
}

.message-data-time {
  //color: lighten($chat-grey, 2%);
  color: #075E54;
  padding-left: 6px;
}
</style>
